(() => {
  'use strict';
  const root = document.body.dataset.root || '/';
  const states = new WeakMap();
  const label = v => ({ schwarz: 'Black', marine: 'Midnight Blue', navy: 'Midnight Blue' }[v.toLowerCase()] || v);
  const colorKey = value => {
    const key = String(value || '').trim().toLowerCase().replace(/\s+/g, ' ');
    return ({ schwarz: 'black', midnight: 'midnight blue', marine: 'midnight blue', navy: 'midnight blue' }[key] || key);
  };
  function mediaColor(alt, colors) {
    // A bare color or a separated prefix/suffix keeps alt text useful as a description.
    const parts = String(alt || '').split(/\s*(?:\||[–—])\s*|\s+-\s+/);
    return parts.map(colorKey).find(part => colors.includes(part));
  }
  const money = cents => new Intl.NumberFormat('en-GB', { style: 'currency', currency: document.body.dataset.currency || 'EUR' }).format(cents / 100);
  function clock() { document.querySelectorAll('[data-clock]').forEach(e => { e.textContent = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Berlin', hour: '2-digit', minute: '2-digit', second: '2-digit' }).format(new Date()); }); }
  clock(); setInterval(clock, 1000);
  try { document.body.classList.toggle('night', localStorage.getItem('ttc-mode') === 'night'); } catch {}

  function initPicker(el) {
    if (states.has(el)) return states.get(el);
    const data = JSON.parse(el.querySelector('[data-variant-data]').textContent);
    const select = el.querySelector('[data-variant-select]');
    const groups = [...el.querySelectorAll('[data-option-position]')];
    const explicit = el.hasAttribute('data-main-picker') ? new URL(location.href).searchParams.get('variant') : null;
    const initial = data.find(v => String(v.id) === explicit) || data.find(v => String(v.id) === el.dataset.defaultId) || data[0];
    const selected = [...initial.options];
    const sizeIndex = groups.findIndex(g => g.dataset.optionKind === 'size');
    if (!explicit && sizeIndex >= 0) selected[sizeIndex] = null;
    const state = { data, selected, variant: null, display: initial, colorIndex: groups.findIndex(g => g.dataset.optionKind === 'color'), el };
    states.set(el, state);
    el.querySelector('[data-variant-fallback]').hidden = true;
    el.querySelector('[data-option-controls]').hidden = false;
    // The native Shopify variant select remains the submitted source of truth.
    function refresh(updateUrl = false) {
      const complete = selected.every(value => value !== null);
      state.variant = complete ? data.find(v => v.options.every((value, i) => value === selected[i])) || null : null;
      state.display = state.variant || data.find(v => v.options.every((value, i) => selected[i] === null || value === selected[i])) || initial;
      select.value = state.variant ? String(state.variant.id) : '';
      el.querySelector('[data-price]').textContent = state.display.formattedPrice;
      groups.forEach((group, i) => {
        group.querySelector('[data-selected-label]').textContent = selected[i] ? label(selected[i]) : 'Select';
        group.querySelectorAll('input').forEach(input => {
          const matches = data.filter(v => v.options[i] === input.value && v.options.every((value, j) => j === i || j === sizeIndex || selected[j] === null || value === selected[j]));
          const available = matches.some(v => v.available);
          input.checked = input.value === selected[i];
          // A color can be inspected even when sold out; unavailable sizes cannot be purchased.
          input.disabled = group.dataset.optionKind === 'size' && !available;
          input.closest('label').dataset.unavailable = String(!available);
          input.nextElementSibling.textContent = label(input.value);
        });
      });
      const availableInColor = data.some(v => v.available && (state.colorIndex < 0 || v.options[state.colorIndex] === selected[state.colorIndex]));
      el.querySelector('[data-availability]').textContent = state.variant ? (state.variant.available ? 'Available' : 'Sold out') : (availableInColor ? 'Select a size' : 'Sold out in this color');
      const mainButton = el.closest('[data-purchase]')?.querySelector('[data-add]');
      if (mainButton && !el.closest('[data-product-page]').dataset.busy) { mainButton.disabled = !state.variant?.available; mainButton.textContent = !availableInColor || state.variant && !state.variant.available ? 'Sold out' : state.variant ? 'Add to bag +' : 'Select a size'; }
      if (updateUrl && el.hasAttribute('data-main-picker')) {
        const url = new URL(location.href);
        if (state.variant) url.searchParams.set('variant', state.variant.id); else url.searchParams.delete('variant');
        history.replaceState({}, '', url);
      }
      el.dispatchEvent(new CustomEvent('ttc:variant', { bubbles: true, detail: state }));
    }
    groups.forEach((group, i) => group.addEventListener('change', e => {
      if (!e.target.matches('[data-option-input]')) return;
      selected[i] = e.target.value;
      if (i === state.colorIndex && sizeIndex >= 0 && selected[sizeIndex]) {
        const match = data.find(v => v.options.every((value, j) => value === selected[j]));
        if (!match?.available) selected[sizeIndex] = null;
      }
      refresh(true);
    }));
    state.refresh = refresh; refresh(); return state;
  }

  function initGallery(page) {
    const gallery = page.querySelector('[data-gallery]'); if (!gallery || gallery.dataset.ready) return;
    gallery.dataset.ready = '1';
    const figures = [...gallery.querySelectorAll('[data-media-id]')];
    const buttons = [...gallery.querySelectorAll('[data-media-target]')];
    const tools = gallery.querySelector('[data-gallery-tools]'); if (tools) tools.hidden = false;
    let visible = figures;
    function syncButtons() {
      buttons.forEach(button => {
        const index = visible.findIndex(figure => figure.dataset.mediaId === button.dataset.mediaTarget);
        button.hidden = index < 0;
        if (index < 0) return;
        const number = index + 1, alt = visible[index].dataset.mediaAlt || '';
        button.textContent = String(number).padStart(2, '0');
        button.setAttribute('aria-label', `View image ${number}${alt ? ': ' + alt : ''}`);
      });
    }
    function show(id) {
      if (!visible.length) return;
      const figure = visible.find(f => f.dataset.mediaId === String(id)) || visible[0];
      figures.forEach(f => { f.hidden = f !== figure; if (f.hidden) f.querySelectorAll('video').forEach(v => v.pause()); });
      buttons.forEach(b => b.setAttribute('aria-pressed', String(b.dataset.mediaTarget === figure.dataset.mediaId)));
      const status = gallery.querySelector('[data-gallery-status]'); if (status) status.textContent = `Image ${visible.indexOf(figure) + 1} of ${visible.length}`;
    }
    syncButtons();
    buttons.forEach(b => b.addEventListener('click', () => show(b.dataset.mediaTarget)));
    gallery.querySelectorAll('[data-gallery-step]').forEach(b => b.addEventListener('click', () => {
      const current = visible.findIndex(f => !f.hidden);
      show(visible[(current + Number(b.dataset.galleryStep) + visible.length) % visible.length]?.dataset.mediaId);
    }));
    page.addEventListener('ttc:variant', e => {
      if (!e.target.hasAttribute('data-main-picker')) return;
      const state = e.detail;
      const colors = state.colorIndex >= 0 ? [...new Set(state.data.map(v => colorKey(v.options[state.colorIndex])))] : [];
      const color = state.colorIndex >= 0 ? colorKey(state.selected[state.colorIndex]) : null;
      visible = figures.filter(f => { const tagged = mediaColor(f.dataset.mediaAlt, colors); return !tagged || tagged === color; });
      syncButtons();
      show(state.display.mediaId);
    });
  }

  function initUniform(page) {
    const uniform = page.querySelector('[data-uniform]'); if (!uniform || uniform.dataset.ready) return;
    uniform.dataset.ready = '1';
    const mainEl = page.querySelector('[data-main-picker]'), partnerEl = uniform.querySelector('[data-product-picker]');
    const form = uniform.querySelector('form'), button = form.querySelector('[data-add]');
    form.querySelector('[data-uniform-actions]').hidden = false;
    function refresh() {
      const main = states.get(mainEl), partner = states.get(partnerEl); if (!main || !partner || page.dataset.busy) return;
      [[ '[data-uniform-main]', main.display.image ], [ '[data-uniform-partner]', partner.display.image ]].forEach(([selector, source]) => {
        const image = uniform.querySelector(selector);
        image.hidden = !source;
        if (source) image.src = source; else image.removeAttribute('src');
      });
      uniform.querySelector('[data-uniform-price]').textContent = money(main.display.price + partner.display.price);
      uniform.querySelector('[data-uniform-main-label]').textContent = `Your selection: ${main.selected.map(v => v ? label(v) : 'choose size above').join(' / ')}`;
      button.disabled = !(main.variant?.available && partner.variant?.available);
      button.textContent = button.disabled ? 'Choose both available sizes' : 'Add both to bag +';
    }
    page.addEventListener('ttc:variant', refresh); refresh();
    form.addEventListener('submit', e => { e.preventDefault(); const main = states.get(mainEl), partner = states.get(partnerEl); if (main.variant?.available && partner.variant?.available) add(form, [{ id: main.variant.id, quantity: 1 }, { id: partner.variant.id, quantity: 1 }]); });
  }

  async function add(form, items) {
    const page = form.closest('[data-product-page]');
    if (page.dataset.busy) return;
    const button = form.querySelector('[data-add]'), status = form.querySelector('.form-status');
    if (button.disabled) return;
    if (document.body.hasAttribute('data-preview')) { status.textContent = 'Design preview — no order or payment is created.'; return; }
    page.dataset.busy = 'true'; button.disabled = true; const previous = button.textContent; button.textContent = 'Adding…'; status.textContent = '';
    const inputs = [...page.querySelectorAll('input,select,[data-add]')]; const priorDisabled = inputs.map(i => i.disabled); inputs.forEach(i => i.disabled = true);
    try {
      const res = await fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) });
      const data = await res.json();
      if (!res.ok) throw new Error(data.description || 'This selection could not be added. Please try again.');
      status.textContent = 'Added to your bag.'; const link = document.createElement('a'); link.href = root + 'cart'; link.textContent = 'View bag →'; status.append(link);
      try { const response = await fetch(root + 'cart.js'); if (response.ok) { const cart = await response.json(); document.querySelectorAll('[data-cart-count]').forEach(e => e.textContent = cart.item_count); } } catch {}
    } catch (error) { status.textContent = error.message || 'Please try again.'; }
    finally { delete page.dataset.busy; inputs.forEach((i, index) => i.disabled = priorDisabled[index]); button.textContent = previous; page.querySelectorAll('[data-product-picker]').forEach(el => states.get(el)?.refresh()); }
  }

  function init(scope = document) {
    scope.querySelectorAll('[data-contact-form]').forEach(form => {
      if (form.dataset.ready) return;
      form.dataset.ready = '1';
      if (form.querySelector('[data-contact-result]')) form.closest('details').open = true;
      if (document.body.hasAttribute('data-preview')) form.addEventListener('submit', event => {
        event.preventDefault();
        form.querySelector('[data-contact-preview-status]').textContent = 'Design preview — no message is sent.';
      });
    });
    scope.querySelectorAll('[data-night]').forEach(b => { if (b.dataset.ready) return; b.dataset.ready = '1'; const sync = () => { const night = document.body.classList.contains('night'); b.setAttribute('aria-pressed', String(night)); b.textContent = night ? 'Day' : 'Night'; }; sync(); b.addEventListener('click', () => { document.body.classList.toggle('night'); sync(); try { localStorage.setItem('ttc-mode', document.body.classList.contains('night') ? 'night' : 'day'); } catch {} }); });
    scope.querySelectorAll('[data-catalog]').forEach(c => c.querySelectorAll('[data-density]').forEach(b => { b.onclick = () => { c.querySelector('.product-grid').classList.toggle('large', b.dataset.density === 'large'); c.querySelectorAll('[data-density]').forEach(x => x.setAttribute('aria-pressed', String(x === b))); }; }));
    scope.querySelectorAll('[data-product-page]').forEach(page => {
      initGallery(page);
      page.querySelectorAll('[data-product-picker]').forEach(initPicker);
      initUniform(page);
      page.querySelectorAll('[data-purchase]').forEach(form => { if (form.dataset.ready) return; form.dataset.ready = '1'; form.addEventListener('submit', e => { e.preventDefault(); const state = states.get(form.querySelector('[data-product-picker]')); if (state.variant?.available) add(form, [{ id: state.variant.id, quantity: 1 }]); }); });
    });
  }
  init(); document.addEventListener('shopify:section:load', e => init(e.target));
})();
